import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,
  Button,Selector,TextArea,ImageUploader,DatePicker,NavBar,Image,Picker,Toast,Grid
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { RightOutline } from 'antd-mobile-icons'

import {
    GetDataDictionarysByCode,SaveNNFile,SavePlanetUserMap,GetPlanetInfo
  } from '../../service/service';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { environment } from '../../service/baseUrl';

import '../Planet/index.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import moment from 'moment';
// moment.locale('zh-cn');

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],

            visibleOne: false,
            valuePickerOne: "0",
            textPickerOne: "请选择",
            pickerOne: [
                [
                ]
            ],

            visibleTwo: false,
            valuePickerTwo: "0",
            textPickerTwo: "请选择",
            pickerTwo: [
                [
                ]
            ],

            imgName: "",
            userInfo: {},
            planetInfo: {},
            id: 0,
        };
    }

    componentDidMount() {
        var that = this;
        GetDataDictionarysByCode("NNSZGX").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickerOne: [arry]
                })
            }
        })

        // GetDataDictionarysByCode("XCX_CH").then(res => {
        //     if (res.success) {
        //         var arry = [];
        //         res.result.map(item => {
        //             arry.push({ label: item.displayName, value: item.id })
        //         })
        //         that.setState({
        //             pickerTwo: [arry]
        //         })
        //     }
        // })

        
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    this.formRef.current.setFieldsValue({
                        Name: res.result.name,
                        FamilyRelationName: (res.result.planetUserMapDtos == null || res.result.planetUserMapDtos.length == 0)
                            ? null : res.result.planetUserMapDtos[0].familyRelationName,
                        FamilyRelationOne: (res.result.planetUserMapDtos == null || res.result.planetUserMapDtos.length == 0)
                            ? null : res.result.planetUserMapDtos[0].familyRelationId,
                    })

                    setTimeout(() => {
                        if (res.result.planetUserMapDtos != null && res.result.planetUserMapDtos.length > 0) {
                            var item1 = that.state.pickerOne[0]
                                .filter(x => x.value == res.result.planetUserMapDtos[0].familyRelationId);
                            that.setState({
                                valuePickerOne: item1[0] == null ? 0 : item1[0].value,
                                textPickerOne: item1[0] == null ? "请选择" : item1[0].label,
                            })
                        }
                    }, 1000);

                    that.setState({
                        id: id,
                        planetInfo: result,
                    })
                }
            })
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    submitForm = () => {
        var that = this;
        this.formRef.current.validateFields()
            .then(values => {
                if (values.Birthday != undefined) {
                    values.Birthday = dayjs(values.Birthday).format("YYYY-MM-DD");
                }
                if (values.DeadDate != undefined) {
                    values.DeadDate = dayjs(values.DeadDate).format("YYYY-MM-DD");
                }
                
                const submitData = {
                    ...that.state.planetInfo,
                    ...values,
                    PlanetId: this.state.id,
                    FamilyRelationId: this.state.valuePickerOne,
                };

                SavePlanetUserMap(submitData).then(res => {
                    if (res.success) {
                        Toast.show({ icon: 'success', content: '提交成功！' });
                        setTimeout(() => {
                            that.props.navigate('/my', { replace: true });
                        }, 2000);
                    }

                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });
    };
    


    render() {

        return (
            <div className="planetUser" style={{ backgroundColor: "rgb(227 227 227)", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/my', { replace: true }); // 传递状态
                }}>
                </NavBar>

                <div style={{ fontSize: "20px", textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                    逝者关系
                </div>

                <div style={{
                    width: "90%", marginLeft: "5%", paddingTop: "10px", backgroundColor: "#fff"
                    , borderTopLeftRadius: "10px", borderTopRightRadius: "10px", marginTop: "20px"
                }}>
                    <Form
                        name='form'
                        ref={this.formRef}
                        layout='horizontal'
                        footer={
                            <div>
                                <div style={{
                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                    , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                    , fontWeight: "600", color: "#fff"
                                }} type='submit' onClick={()=>{
                                    this.submitForm();
                                }}>
                                    确 定
                                </div>
                            </div>
                        }
                    >


                        <Form.Item
                            name='Name'
                            label='逝者姓名'
                            rules={[{ required: true, message: '请输入相关内容' }]}
                        >
                            <Input disabled onChange={console.log} placeholder='请输入相关内容' />
                        </Form.Item>

                        <Form.Item name='FamilyRelationOne' label="你是Ta的">
                            <div onClick={() => {
                                this.setState({
                                    visibleOne: true
                                })
                            }} style={{
                                display: "flex",
                                alignItems: "center", // 垂直居中
                                justifyContent: "flex-end", // 内容右对齐
                            }}>
                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                    {this.state.textPickerOne}
                                </span>
                                <span style={{ float: "right" }}>
                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                </span>
                            </div>

                            <Picker
                                columns={this.state.pickerOne}
                                visible={this.state.visibleOne}
                                onClose={() => {
                                    this.setState({
                                        visibleOne: false
                                    })
                                }}
                                value={[this.state.valuePickerOne]}
                                onConfirm={(v) => {
                                    var value = v[0];
                                    var item = this.state.pickerOne[0].filter(x => x.value == value)
                                    this.setState({
                                        valuePickerOne: value,
                                        textPickerOne: item[0].label
                                    })
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name='FamilyRelationName'
                            label='Ta称呼你为'
                            rules={[{ required: true, message: '请输入相关内容' }]}
                        >
                            <Input onChange={console.log} placeholder='请输入相关内容' />
                        </Form.Item>

                    </Form>

                </div>


                <BottomMenu  position="absolute" selectKey="my" />

            </div>
        )
    }
}

export default withNavigate(Index);